import {
  PlaylistAdd,
  Search,
  LocalOffer,
  AutoAwesome,
  Backup,
  Image,
  TrendingUp,
  Lightbulb,
  Videocam,
  Email,
  CodeOutlined,
  DataArray,
  ClosedCaption,
} from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DnsIcon from "@mui/icons-material/Dns";
import DescriptionIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import EmailIcon from "@mui/icons-material/Email";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import CodeIcon from "@mui/icons-material/Code";
import Security from "@mui/icons-material/Security";
import TagIcon from "@mui/icons-material/Tag";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

export const categoryDescriptions = {
  "YouTube Tools":
    "Supercharge your YouTube workflow with these powerful creator tools.",
  "Web Scraping Tools":
    "Extract and analyze data efficiently from the web and popular platforms.",
  "Email Tools":
    "Boost your email campaigns and validation processes with smart utilities.",
  "Data Tools":
    "Convert, format, and validate your data with reliable and easy-to-use tools.",
  default:
    "Explore these innovative tools designed to enhance your productivity.",
};

export const HomePageToolsDetails = [
  {
    title: "Playlist Exporter",
    description:
      "Export YouTube playlists to various formats for easy sharing and backup",
    icon: <PlaylistAdd fontSize="large" />,
    url: "/youtube/playlistExport",
    color: "#FF6B6B",
    category: "YouTube Tools",
  },
  {
    title: "Tags Rank Checker",
    description:
      "Analyze how your video tags rank and optimize for better visibility",
    icon: <LocalOffer fontSize="large" />,
    url: "/youtube/tags-rank-checker",
    color: "#4ECDC4",
    category: "YouTube Tools",
  },
  {
    title: "Search Results Export",
    description: "Export YouTube search results for research and analysis",
    icon: <Search fontSize="large" />,
    url: "/youtube/searchResultsExport",
    color: "#45B7D1",
    category: "YouTube Tools",
  },
  {
    title: "Smart Tag Generator",
    description:
      "Generate optimal tags for your videos to boost discoverability",
    icon: <AutoAwesome fontSize="large" />,
    url: "/youtube/tagGenerator",
    color: "#A37EBA",
    category: "YouTube Tools",
  },
  {
    title: "Search Results Scraper",
    description: "Export Google search results for SEO analysis",
    icon: <Search fontSize="large" />,
    url: "/google/search-results-export",
    color: "#F7C46C",
    category: "Web Scraping Tools",
  },
  {
    title: "Title Generator",
    description: "Create compelling titles that increase click-through rates",
    icon: <Videocam fontSize="large" />,
    url: "/youtube/video-title-generator",
    color: "#FF8E53",
    category: "YouTube Tools",
  },
  {
    title: "Channel Backup",
    description: "Backup your entire YouTube channel data safely",
    icon: <Backup fontSize="large" />,
    url: "/youtube/channelBackUp",
    color: "#98D8C8",
    category: "YouTube Tools",
  },
  {
    title: "Thumbnail Downloader",
    description: "Download high-quality thumbnails from any video",
    icon: <Image fontSize="large" />,
    url: "/youtube/thumbnailDownloader",
    color: "#F06292",
    category: "YouTube Tools",
  },
  {
    title: "Video Rank Checker",
    description: "Track your video rankings for specific keywords",
    icon: <TrendingUp fontSize="large" />,
    url: "/youtube/video-rank-checker",
    color: "#7986CB",
    category: "YouTube Tools",
  },
  {
    title: "Keyword Suggestions",
    description: "Get auto-suggested keywords to boost your content strategy",
    icon: <Lightbulb fontSize="large" />,
    url: "/youtube/keyword-auto-suggestion",
    color: "#9575CD",
    category: "YouTube Tools",
  },
  {
    title: "Bulk Email Validator",
    description: "Upload a list of emails and get verified status in seconds",
    icon: <Lightbulb fontSize="large" />,
    url: "/misc/bulk-email-validator-tool",
    color: "#9575CD",
    category: "Email Tools",
  },
  {
    title: "Product Scraper",
    description: "Upload ASIN list and receive product data in CSV",
    icon: <Lightbulb fontSize="large" />,
    url: "/misc/amazon-product-scraper",
    color: "#9575CD",
    category: "Web Scraping Tools",
  },
  {
    title: "Random Email Generator",
    description: "Generate random email addresses for testing purposes",
    icon: <Email fontSize="large" />,
    url: "/random-email-generator",
    color: "#9575CD",
    category: "Email Tools",
  },
  {
    title: "JSON To CSV Converter",
    description: "Convert JSON data to CSV format for easier analysis",
    icon: <CodeOutlined fontSize="large" />,
    url: "/json-to-csv",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "CSV To JSON Converter",
    description: "Convert CSV data to JSON format for easier manipulation",
    icon: <DataArray fontSize="large" />,
    url: "/csv-to-json",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "Transcript Downloader",
    description: "Download transcripts from YouTube videos easily",
    icon: <ClosedCaption fontSize="large" />,
    url: "/youtube-transcript-downloader",
    color: "#9575CD",
    category: "YouTube Tools",
  },
  {
    title: "Timestamp Generator",
    description: "Automatically create precise video chapters in seconds ",
    icon: <AccessTimeIcon fontSize="large" />,
    url: "/youtube-timestamper-generator",
    color: "#9575CD",
    category: "YouTube Tools",
  },
  {
    title: "Random IP Address Generator",
    description: "Generate random IP addresses for testing and development",
    icon: <DnsIcon fontSize="large" />,
    url: "/generate-random-ip-address",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "XML to JSON Converter",
    description: "Convert XML data to JSON format for easier manipulation",
    icon: <DescriptionIcon fontSize="large" />,
    url: "/xml-to-json-converter",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "YAML to JSON Converter",
    description: "Convert YAML data to JSON format for easier manipulation",
    icon: <SettingsIcon fontSize="large" />,
    url: "/yaml-to-json-converter",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "JSON to YAML Converter",
    description: "Convert JSON data to YAML format for easier manipulation",
    icon: <CompareArrowsIcon fontSize="large" />,
    url: "/json-to-yaml-converter",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "Email Validation Checker",
    description: "Check if an email address is valid and deliverable",
    icon: <EmailIcon fontSize="large" />,
    url: "/email-validation-checker",
    color: "#9575CD",
    category: "Email Tools",
  },
  {
    title: "Email Alias Generator",
    description: "Generate alias email to filter spam and unwanted emails",
    icon: <AlternateEmailIcon fontSize="large" />,
    url: "/email-alias-generator",
    color: "#9575CD",
    category: "Email Tools",
  },
  {
    title: "Keyword Suggestion",
    description: "Get keyword suggestions from Google for SEO",
    icon: <Search fontSize="large" />,
    url: "/google-keyword-auto-suggestion",
    color: "#9575CD",
    category: "Web Scraping Tools",
  },
  {
    title: "URL Encoder",
    description: "Encode URLs to make them safe for transmission",
    icon: <LockIcon fontSize="large" />,
    url: "/url-encoder-online",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "URL Decoder",
    description: "Decode URLs to retrieve the original string",
    icon: <LockOpenIcon fontSize="large" />,
    url: "/url-decoder-online",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "JSON Formatter",
    description: "Format and beautify your JSON data easily",
    icon: <CodeIcon fontSize="large" />,
    url: "/json-formatter-online",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "SSL Certificate Checker",
    description: "Check the validity and details of SSL certificates",
    icon: <Security fontSize="large" />,
    url: "/ssl-certificate-checker",
    color: "#9575CD",
    category: "Data Tools",
  },
  {
    title: "Tag Extractor",
    description: "Extract tags from YouTube videos for analysis",
    icon: <TagIcon fontSize="large" />,
    url: "/youtube-tag-extractor",
    color: "#9575CD",
    category: "YouTube Tools",
  },
  {
    title: "Disposable Email Checker",
    description: "Check if an email address is disposable",
    icon: <MailOutlineIcon fontSize="large" />,
    url: "disposable-email-checker",
    color: "#9575CD",
    category: "Email Tools",
  },
  {
    title: "YouTube Description Extractor",
    description: "Extract video descriptions from YouTube",
    icon: <DescriptionIcon fontSize="large" />,
    url: "/youtube/description-extractor",
    color: "#9575CD",
    category: "YouTube Tools",
  },
];

export const toolLinks = {
  "YouTube Playlist Export": "/youtube/playlistExport",
  "YouTube Tags Rank Checker": "/youtube/tags-rank-checker",
  "YouTube Search Results Export": "/youtube/searchResultsExport",
  "YouTube Tags Generator": "/youtube/tagGenerator",
  "Google Search Results Scraper": "/google/search-results-export",
  "YouTube Titles Generator": "/youtube/video-title-generator",
  "YouTube Channel BackUp": "/youtube/channelBackUp",
  "YouTube Thumbnail Grabber": "/youtube/thumbnailDownloader",
  "YouTube Video Rank Checker": "/youtube/video-rank-checker",
  "YouTube Keyword Suggestion": "/youtube/keyword-auto-suggestion",
  "Bulk Email Validator": "/misc/bulk-email-validator-tool",
  "Amazon Product Scraper": "/misc/amazon-product-scraper",
  "Random Email Generator": "/random-email-generator",
  "JSON to CSV Converter": "/json-to-csv",
  "CSV to JSON Converter": "/csv-to-json",
  "YouTube Transcript Downloader": "/youtube-transcript-downloader",
  "YouTube Timestamp Generator": "/youtube-timestamper-generator",
  "Random IPs Generator": "/generate-random-ip-address",
  "XML to JSON Converter": "/xml-to-json-converter",
  "YAML to JSON Converter": "/yaml-to-json-converter",
  "JSON to YAML Converter": "/json-to-yaml-converter",
  "Email Validation Checker": "/email-validation-checker",
  "Email Alias Generator": "/email-alias-generator",
  "Google Keyword Suggestion": "/google-keyword-auto-suggestion",
  "URL Encoder Online": "/url-encoder-online",
  "URL Decoder Online": "/url-decoder-online",
  "JSON Formatter Online": "/json-formatter-online",
  "SSL Certificate Checker": "/ssl-certificate-checker",
  "YouTube Tag Extractor": "/youtube-tag-extractor",
  "Disposable Email Checker": "/disposable-email-checker",
  "YouTube Description Extractor": "/youtube/description-extractor",
};

// Group tools by category
export const toolCategories = {
  "YouTube Tools": [
    "YouTube Playlist Export",
    "YouTube Tags Rank Checker",
    "YouTube Search Results Export",
    "YouTube Tags Generator",
    "YouTube Titles Generator",
    "YouTube Channel BackUp",
    "YouTube Thumbnail Grabber",
    "YouTube Video Rank Checker",
    "YouTube Keyword Suggestion",
    "YouTube Transcript Downloader",
    "YouTube Timestamp Generator",
    "YouTube Tag Extractor",
    "YouTube Description Extractor",
  ],
  "Web Scraping Tools": [
    "Google Search Results Scraper",
    "Amazon Product Scraper",
    "Google Keyword Suggestion",
  ],
  "Email Tools": [
    "Bulk Email Validator",
    "Random Email Generator",
    "Email Validation Checker",
    "Email Alias Generator",
    "Disposable Email Checker",
  ],
  "Data Tools": [
    "JSON to CSV Converter",
    "CSV to JSON Converter",
    "Random IPs Generator",
    "XML to JSON Converter",
    "YAML to JSON Converter",
    "JSON to YAML Converter",
    "URL Encoder Online",
    "URL Decoder Online",
    "JSON Formatter Online",
    "SSL Certificate Checker",
  ],
};

export const toolFeatures = [
  {
    name: "YouTube Playlist Export",
    description: "Export videos from any public playlist as CSV.",
    plans: {
      free: "Export only the first 50% of videos from a playlist",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
    creditsTooltip:
      "Starter & above users can export the full playlist with 1 credit.",
  },
  {
    name: "YouTube Tags Rank Checker",
    description: "See how your video tags are ranking on YouTube.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "YouTube Search Results Export",
    description: "Scrape YouTube search results into CSV.",
    plans: {
      free: "Upto 5 Search results",
      starter: "Upto 100 Search results",
      growth: "Upto 100 Search results",
      pro: "Upto 100 Search results",
      business: "Upto 100 Search results",
    },
    credits: 1,
  },
  {
    name: "YouTube Tags Generator",
    description: "Generate optimized tags based on video keywords.",
    plans: {
      free: "Few masked tags",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "Google Search Results Scraper",
    description: "Export organic search results from Google.",
    plans: {
      free: "Upto 10 Search results",
      starter: "Upto 100 Search results",
      growth: "Upto 100 Search results",
      pro: "Upto 100 Search results",
      business: "Upto 100 Search results",
    },
    credits: 1,
  },
  {
    name: "YouTube Titles Generator",
    description: "Generate catchy video titles using AI.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "YouTube Channel BackUp",
    description: "Download all video metadata from any channel.",
    plans: {
      free: "Upto 10 Videos per Channel",
      starter: "Upto 500 Videos per Channel",
      growth: "Upto 500 Videos per Channel",
      pro: "Upto 500 Videos per Channel",
      business: "Upto 500 Videos per Channel",
    },
    credits: 1,
  },
  {
    name: "YouTube Thumbnail Grabber",
    description: "Download high-quality thumbnails from videos.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "YouTube Video Rank Checker",
    description: "Check how your video ranks for various keywords.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "YouTube Keyword Suggestion",
    description: "Get keyword ideas using YouTube's autocomplete.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "Bulk Email Validator",
    description: "Clean email lists by removing invalid addresses.",
    plans: {
      free: "Validate up to 5 emails/csv",
      starter: "Validate up to 50 emails/csv",
      growth: "Validate up to 200 emails/csv",
      pro: "Validate up to 5000 emails/csv",
      business: "Validate up to 10000 emails/csv",
    },
    credits: 1,
  },
  {
    name: "Amazon Product Scraper",
    description: "Scrape product details from Amazon listings.",
    plans: {
      free: "Upto 5 ASINs",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 2,
    creditsTooltip: "Each ASIN uses 2 Credits due to high CPU consumption.",
  },
  {
    name: "Random Email Generator",
    description: "Generate random email addresses for testing.",
    plans: {
      free: "Generate upto 100 emails/credit",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per generation",
  },
  {
    name: "JSON to CSV Converter",
    description: "Convert JSON data to CSV format.",
    plans: {
      free: "Convert upto 10 JSON to CSV",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per conversion",
  },
  {
    name: "CSV to JSON Converter",
    description: "Convert CSV data to JSON format.",
    plans: {
      free: "Convert upto 10 CSVs to JSON",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans Free plan: 1 credit per conversion",
  },
  {
    name: "YouTube Transcript Downloader",
    description: "Download transcripts from YouTube videos.",
    plans: {
      free: "Download 50% of the video transcript",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "YouTube Timestamp Generator",
    description: "Generate timestamps for YouTube videos.",
    plans: {
      free: "Get timestamp for first half of the video",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "Random IPs Generator",
    description: "Generate random IP addresses for testing.",
    plans: {
      free: "Generate upto 100 IPs/credit",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per generation",
  },
  {
    name: "XML to JSON Converter",
    description: "Convert XML data to JSON format.",
    plans: {
      free: "Convert upto 10 XMLs to JSON",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per conversion",
  },
  {
    name: "YAML to JSON Converter",
    description: "Convert YAML data to JSON format.",
    plans: {
      free: "Convert upto 10 YAMLs to JSON",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per conversion",
  },
  {
    name: "JSON to YAML Converter",
    description: "Convert JSON data to YAML format.",
    plans: {
      free: "Convert upto 10 JSONs to YAML",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per conversion",
  },
  {
    name: "Email Validation Checker",
    description: "Check if an email address is valid.",
    plans: {
      free: "Validate upto 5 emails/credit",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per validation",
  },
  {
    name: "Email Alias Generator",
    description: "Generate alias email addresses for filtering.",
    plans: {
      free: "Generate upto 10 aliases/credit",
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per alias generation",
  },
  {
    name: "Google Keyword Suggestion",
    description: "Get keyword suggestions from Google.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "URL Encoder Online",
    description: "Encode URLs to make them safe for transmission.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per input",
  },
  {
    name: "URL Decoder Online",
    description: "Decode URLs to retrieve the original string.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per input",
  },
  {
    name: "JSON Formatter Online",
    description: "Format and beautify your JSON data easily.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per input",
  },
  {
    name: "SSL Certificate Checker",
    description: "Check the validity and details of SSL certificates.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per input",
  },
  {
    name: "YouTube Tag Extractor",
    description: "Extract tags from YouTube videos for analysis.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
  {
    name: "Disposable Email Checker",
    description: "Check if an email address is disposable.",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: "",
    creditsTooltip:
      "No credits needed on any paid plans. Free plan: 1 credit per input",
  },
  {
    name: "YouTube Description Extractor",
    description: "Extract video descriptions from YouTube",
    plans: {
      free: true,
      starter: true,
      growth: true,
      pro: true,
      business: true,
    },
    credits: 1,
  },
];
